import React from 'react'

import AccentColor from '~co/collections/item/accentColor'
import Drop from '../dnd/drop'

export default function BookmarksContainerWrap({ spaceId, children }) {
    return (
        <AccentColor _id={spaceId}>{style=>
            <Drop spaceId={spaceId}>{({ dropHandlers, isDropping })=>
                <div 
                    className={`${'ui-bm-wrap'} ${isDropping && 'ui-bm-is-dropping'}`}
                    style={style}
                    {...dropHandlers}>
                    {children}
                </div>
            }</Drop>
        }</AccentColor>
    )
}